var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-stepper",
    {
      staticClass: "elevation-0",
      model: {
        value: _vm.curStep,
        callback: function ($$v) {
          _vm.curStep = $$v
        },
        expression: "curStep",
      },
    },
    [
      _c(
        "v-stepper-header",
        {
          staticClass: "elevation-0",
          class: _vm.backgroundColor,
          staticStyle: { height: "auto" },
        },
        [
          _vm._l(_vm.items, function (item, n) {
            return [
              _c(
                "v-stepper-step",
                {
                  key: n + 1 + "-step",
                  staticClass: "pa-4",
                  attrs: { complete: _vm.curStep > n + 1, step: n + 1 },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("step", n + 1)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t(item)))]
              ),
              n !== _vm.items.length - 1
                ? _c("v-divider", { key: n + 1 + "-line", staticClass: "ma-0" })
                : _vm._e(),
            ]
          }),
        ],
        2
      ),
      _c(
        "v-stepper-items",
        { staticClass: "pt-1", class: _vm.backgroundColor },
        _vm._l(_vm.items, function (item, n) {
          return _c(
            "v-stepper-content",
            {
              key: n + 1 + "-content",
              staticClass: "rounded-t elevation-0",
              class: _vm.contentClass,
              attrs: { step: n + 1 },
            },
            [_vm._t("content-" + (n + 1))],
            2
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }